<template>
  <div class="w-full h-full">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// This component now only serves as a layout container for the admin panel's nested routes.
// The main layout and navigation are handled by AppLayout.vue.
</script>
